'use strict';

var $ = require('jquery');
var slick = require('slick-carousel');

function recentClosings() {
	$('.recentClosingsGroup__itemsInner').slick({
		autoplay: true,
		autoplaySpeed: 3000,
		nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
		prevArrow: '<button type="button" class="slick-prev"><span>Prev</span></button>',
		mobileFirst: true,
		variableWidth: true,
	});
}

module.exports = {
	init: function () {
		recentClosings();
	}
}